/**
* @requires ./framework/frc.init.js
*/

$(function() {
	$body = $('body');

	frc.init.all();

	if ($body.hasClass('home')) { // Home page
		new frc.modules.instagramFeed().init();
		frc.pages.home.init();
	}

	if ($body.hasClass('locations')) { // Locations section
		frc.pages.locations.init();
	}

	if ($body.hasClass('location')) { // Location details page
		frc.pages.locationDetail.init();
	}
    if ($body.hasClass('contact-reviews')) { // contact-review page
        frc.pages.contactReview.init();
    }
    else if ($body.hasClass('contact')) { // Contact page
		frc.pages.contact.init();
	}

	if ($body.hasClass('careers')) { // Careers section
		if ($body.hasClass('landing')) {  // Careers landing page
			new frc.modules.videoCarousel('.video-carousel .swiper-container');
		}
		if ($body.hasClass('search')) { // Careers search page
			frc.pages.careersSearch.init();
		}
	}

	if ($body.hasClass('menus')) { // Menus page
		frc.pages.menus.init();
	}

	if ($body.hasClass('menu')) { // Menu detail page
		frc.pages.menuDetail.init();
	}

	if ($body.hasClass('four-oh-four')) {
		window.setTimeout(function(){
			window.location.href = "/";
		}, 3000);
	}

    $('.order-now-nav-controls').on('click', function(){
        const el = $('#order-now-submenu');
        if ( el.hasClass('active') ) {
            el.removeClass('active');
        } else {
            el.addClass('active');
        }
    });

	$(document).click(function(e){
	    if($(e.target).closest('.order-now-nav-controls').length !== 0
	        && $(e.target).closest('.head-pickup').length === 0
	        && $(e.target).closest('.head-delivery').length === 0
	    ) {
	        return false;
	    }
	    $('#order-now-submenu').removeClass('active');
	});
});


$(window).on('resize',function() {
    var bodyHeight = $("body").height();
	var vwptHeight = $(window).height();

	if (vwptHeight > bodyHeight) {
    	$("body").css({
    		"display": "flex",
    		"flex-direction": "column",
    		"height": "100vh"
    	});
    	$("main").css({
    		"flex": "1 0 auto"
    	});
    	$("footer").css({
    		"flex-shrink": "0"
    	});
	}
}).trigger('resize');
